export default "__VITE_ASSET__D8r6pW4C__"